module.exports = __webpack_public_path__ + "static/img/entretencion_category.847f0a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old/entretencion_category.jpg
// module id = Fay+
// module chunks = 1